import { render, staticRenderFns } from "./GrnIndexreturn.vue?vue&type=template&id=d6d713ac"
import script from "./GrnIndexreturn.vue?vue&type=script&lang=js"
export * from "./GrnIndexreturn.vue?vue&type=script&lang=js"
import style0 from "./GrnIndexreturn.vue?vue&type=style&index=0&id=d6d713ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports